import Image from 'next/image';
import { useState } from 'react';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { ModalMobile, ModalDesktop } from '@acko-tech/building-blocks.ui.modal';
import { getCoverage, getImageBasePath } from 'utils/generics';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';
import PlanDetails from './planDetails';
import * as Styles from './styles';
import { useFetchParams } from 'hooks/useFetchParams';
import { Partners } from 'utils/constants';

interface IProps {
    planId: string;
    name: string;
    benefits: string[];
    premium: number;
    planCategory: string;
    programId: string;
    onClick: any;
    discountedAmount?: number;
    reason?: string;
    eligible: boolean;
    productCode?: string;
    emiEnabled?: boolean;
}

function PlanDetailsCard({
    planId,
    name,
    benefits,
    premium,
    planCategory,
    programId,
    onClick,
    discountedAmount,
    eligible,
    reason,
    productCode,
    emiEnabled = false,
}: IProps) {
    const { isMobile } = useResponsiveDevice();
    const [showModal, setShowModal] = useState(false);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState<
        'FULL' | 'EMI' | null
    >(null);
    const { partner } = useFetchParams();

    const Modal: any = isMobile ? ModalMobile : ModalDesktop;

    return (
        <Styles.CardWrapper>
            <Styles.PlanTitle>{name}</Styles.PlanTitle>
            {(benefits || []).map((benefit) => (
                <Styles.BenefitFlex key={benefit}>
                    <Styles.GreenTickFlex>
                        <Image
                            width={'20px'}
                            height={'20px'}
                            alt={''}
                            src={getImageBasePath('/icons/greenTick.svg')}
                        />
                    </Styles.GreenTickFlex>
                    <Styles.BenefitText>{benefit}</Styles.BenefitText>
                </Styles.BenefitFlex>
            ))}
            <Styles.SeeDetails onClick={() => setShowModal(true)}>
                See Details
            </Styles.SeeDetails>
            {emiEnabled && (
                <Styles.PaymentModeSection>
                    <Styles.PaymentModeLabel>
                        Choose payment mode <span>*</span>
                    </Styles.PaymentModeLabel>
                    <Styles.PaymentModeOptions>
                        <Styles.PaymentModeButton
                            isSelected={selectedPaymentMode === 'FULL'}
                            onClick={() => setSelectedPaymentMode('FULL')}
                        >
                            Pay in full
                        </Styles.PaymentModeButton>
                        <Styles.PaymentModeButton
                            isSelected={selectedPaymentMode === 'EMI'}
                            onClick={() => setSelectedPaymentMode('EMI')}
                        >
                            Pay in EMI
                        </Styles.PaymentModeButton>
                    </Styles.PaymentModeOptions>
                </Styles.PaymentModeSection>
            )}
            <Styles.Hr />
            <Styles.BottomFlex>
                {eligible ? (
                    <>
                        <Styles.PriceWrapper>
                            {discountedAmount || discountedAmount === 0 ? (
                                <Styles.PriceDivFlex>
                                    <div style={{ display: 'flex' }}>
                                        <Styles.StrikedPriceFlex>
                                            ₹{premium}
                                        </Styles.StrikedPriceFlex>
                                        <Styles.PriceFlex>
                                            ₹{discountedAmount}
                                        </Styles.PriceFlex>
                                    </div>
                                    <Styles.GSTText>
                                        (incl 18% GST)
                                    </Styles.GSTText>
                                </Styles.PriceDivFlex>
                            ) : (
                                <Styles.PriceDivFlex>
                                    <div style={{ display: 'flex' }}>
                                        <Styles.PriceFlex>
                                            ₹{premium}
                                        </Styles.PriceFlex>
                                        {partner !== Partners.HERO_VIDA && (
                                            <Styles.SlashYear>
                                                / year
                                            </Styles.SlashYear>
                                        )}
                                    </div>
                                    <Styles.GSTText>
                                        (incl 18% GST)
                                    </Styles.GSTText>
                                </Styles.PriceDivFlex>
                            )}
                        </Styles.PriceWrapper>
                        <Styles.BuyFlexWrapper>
                            <Styles.BuyFlex>
                                <PrimaryButton
                                    size={'small'}
                                    disabled={
                                        emiEnabled && !selectedPaymentMode
                                    }
                                    onClick={() =>
                                        onClick(
                                            planId,
                                            name,
                                            premium,
                                            planCategory,
                                            programId,
                                            emiEnabled,
                                            emiEnabled
                                                ? selectedPaymentMode
                                                : 'FULL',
                                            productCode
                                        )
                                    }
                                >
                                    Select
                                </PrimaryButton>
                            </Styles.BuyFlex>
                            {emiEnabled && (
                                <Styles.HelperText>
                                    Pick a payment mode to continue
                                </Styles.HelperText>
                            )}
                        </Styles.BuyFlexWrapper>
                    </>
                ) : (
                    <Styles.PriceWrapper>{reason}</Styles.PriceWrapper>
                )}
            </Styles.BottomFlex>
            <Modal
                header={<></>}
                show={showModal}
                onHide={() => setShowModal(false)}
                padding={'20px'}
                wrapperStyles={`border-radius: 16px 16px 0px 0px;`}
                showOverlayBackground={true}
            >
                <PlanDetails plans={getCoverage(planCategory || '')} />
            </Modal>
        </Styles.CardWrapper>
    );
}

export default PlanDetailsCard;
